import React from 'react'
import { Form } from 'react-bootstrap'
import { ariaDescribedByIds } from '@rjsf/utils'
import { type ZocksReferenceWidgetProps } from './registry'

export interface RawReferenceFallbackProps extends ZocksReferenceWidgetProps {
  reason?: string
}

export const RawReferenceFallback: React.FC<RawReferenceFallbackProps> = ({ value, onChange, disabled, label, id, reason }) => (
  <div>
    <Form.Control
      id={id}
      type='text'
      value={value}
      disabled={disabled}
      aria-label={label}
      aria-describedby={`${ariaDescribedByIds(id)} ${id}__fallback-reason`}
      onChange={(event) => onChange(event.target.value === '' ? undefined : event.target.value)}
    />
    <div id={`${id}__fallback-reason`} className='paragraph-small text-muted'>
      {reason ?? 'Unsupported reference type'}
    </div>
  </div>
)
